import { render, staticRenderFns } from "./KYC3Auth.vue?vue&type=template&id=1d2d59a0&scoped=true"
import script from "./KYC3Auth.vue?vue&type=script&lang=js"
export * from "./KYC3Auth.vue?vue&type=script&lang=js"
import style0 from "./KYC3Auth.vue?vue&type=style&index=0&id=1d2d59a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2d59a0",
  null
  
)

export default component.exports